module.exports = __webpack_public_path__ + "static/widget-img-1-96193121cabd95a12633abea5dfcb9da.png";